import clsx from "clsx";

export function BulletSteps({
	steps,
	selectedIndex,
	navRef,
}: {
	steps: Record<string, any>;
	selectedIndex: number;
	navRef?: boolean;
}) {
	return (
		<nav
			className={clsx(
				navRef ? "eL-mb-3" : "eL-mb-0",
				"eL-text-[--eL-theme-accent] eL-flex eL-items-center eL-justify-center",
			)}
			aria-label="Progress"
		>
			{steps.map((step: any) => (
				<p
					key={step.id}
					className="!eL-pb-0 eL-text-[--theme-accent] eL-text-md eL-font-medium eL-leading-4"
				>
					{step.id < selectedIndex ? "" : step.id === selectedIndex ? step.name : ""}
				</p>
			))}
			<ol
				role="list"
				className="!eL-mb-0 eL-ml-5 eL-mr-5 eL-flex eL-items-center eL-space-x-3 sm:eL-space-x-5 sm:eL-ml-8"
			>
				{steps.map((step: any) => (
					<li key={step.id} className="!eL-list-none !eL-pb-0">
						{step.id < selectedIndex ? (
							<button
								className="eL-block eL-h-2.5 eL-w-2.5 eL-rounded-full eL-bg-[--eL-theme-color] eL-hover:bg-[--eL-hover-color]"
								aria-label={step.name}
							>
								<span className="eL-sr-only"></span>
							</button>
						) : step.id === selectedIndex ? (
							<button
								className="eL-relative eL-flex eL-items-center eL-justify-center"
								aria-label={step.name}
								aria-current="step"
							>
								<span
									className="eL-absolute eL-flex eL-h-5 eL-w-5 eL-p-px"
									aria-hidden="true"
								>
									<span className="eL-h-full eL-w-full eL-rounded-full eL-bg-[--eL-bullet-bg]" />
								</span>
								<span
									className="eL-relative eL-block eL-h-2.5 eL-w-2.5 eL-rounded-full eL-bg-[--eL-theme-color]"
									aria-hidden="true"
								/>
								<span className="eL-sr-only"></span>
							</button>
						) : (
							<button
								className="eL-block eL-h-2.5 eL-w-2.5 eL-rounded-full eL-bg-gray-200 hover:eL-bg-gray-400"
								aria-label={step.name}
							>
								<span className="eL-sr-only"></span>
							</button>
						)}
					</li>
				))}
			</ol>
		</nav>
	);
}
